import script from "./PuzzleExtractPlaceholder.vue?vue&type=script&setup=true&lang=ts"
export * from "./PuzzleExtractPlaceholder.vue?vue&type=script&setup=true&lang=ts"

import "./PuzzleExtractPlaceholder.vue?vue&type=style&index=0&id=1052332c&scoped=true&lang=scss"

import exportComponent from "D:\\wamp\\www\\GSALT\\gsalt-matters-ibd-denmark\\web\\modules\\vuejs\\vuejs-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1052332c"]])

export default __exports__